import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as chatsRegisterSelectors from './selectors';

export default reducer;
